import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Paper,
  List,
  ListItemButton,
  Divider,
  Typography,
  CircularProgress,
} from "@mui/material";
import DashboardLayout from "../layouts/DashboardLayout";
import axios from "../config/axiosConfig";
import NotificationRow from "../components/notifications/NotificationRow";
import { resolveNotificationUrl } from "../components/notifications/notificationHelpers";

const NotificacionesPage = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const loadNotificaciones = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const { data } = await axios.get("/api/notificaciones");
      setItems(data?.items || data?.notificaciones || []);
    } catch (e) {
      console.error("Error cargando notificaciones:", e);
      setError("No se pudieron cargar las notificaciones.");
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadNotificaciones();
  }, [loadNotificaciones]);

  const handleClickItem = (n) => {
    resolveNotificationUrl(n, navigate);
  };

  return (
    <DashboardLayout>
      <Box sx={{ maxWidth: 760, mx: "auto" }}>
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
          Notificaciones
        </Typography>

        <Paper variant="outlined" sx={{ overflow: "hidden" }}>
          {loading && (
            <Box sx={{ display: "flex", justifyContent: "center", py: 5 }}>
              <CircularProgress size={28} />
            </Box>
          )}

          {!loading && error && (
            <Box px={2} py={3}>
              <Typography variant="body2" color="error">
                {error}
              </Typography>
            </Box>
          )}

          {!loading && !error && items.length === 0 && (
            <Box px={2} py={3}>
              <Typography variant="body2" color="text.secondary">
                No tienes notificaciones por ahora.
              </Typography>
            </Box>
          )}

          {!loading && !error && items.length > 0 && (
            <List disablePadding>
              {items.map((n, idx) => {
                const key = [
                  n.tipo || "item",
                  n.id != null ? String(n.id) : "noid",
                  n.fecha || n.created_at || n.creado_en || "nofecha",
                  idx,
                ].join("-");

                return (
                  <React.Fragment key={key}>
                    {idx > 0 && <Divider component="li" />}
                    <ListItemButton
                      onClick={() => handleClickItem(n)}
                      sx={{ alignItems: "flex-start", py: 0.85, px: 2 }}
                    >
                      <NotificationRow n={n} avatarSize={34} />
                    </ListItemButton>
                  </React.Fragment>
                );
              })}
            </List>
          )}
        </Paper>
      </Box>
    </DashboardLayout>
  );
};

export default NotificacionesPage;
